import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import { AuthContext } from '../../shared/context/auth-context';

import Input from "../../shared/components/formElements/Input";
import Button from "../../shared/components/formElements/Button";
import Card from "../../shared/components/UIElements/Card";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_MAXLENGTH,
  VALIDATOR_SPECIAL_CHARACHTER,
  VALIDATOR_NUMERIC
} from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/form-hook";
import { useHttpClient } from "../../shared/hooks/http-hook";
import "./SpecialOrders.css";
import { formatPhoneNumber } from "../../print/page/Print";
import Capitalize from "../../shared/components/UIElements/Capitalize ";

const UpdateSpecialOrder = () => {
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const specialOrderID = useParams().specialOrderId;
  const [identifiedSpecialOrder, setIdentifiedSpecialOrder] = useState();

  const history = useHistory();

  const [formState, inputHandler, setFormData] = useForm(
    {
      style: {
        value: "",
        isValid: true,
      },
      company: {
        value: "",
        isValid: true,
      },
      color: {
        value: "",
        isValid: true,
      },
      USSize: {
        value: "",
        isValid: true,
      },
      cost: {
        value: "",
        isValid: true,
      },
      price: {
        value: "",
        isValid: true,
      },
      customer: {
        value: "",
        isValid: true,
      },
      startDate: {
        value: "",
        isValid: true,
      },
      eventDate: {
        value: "",
        isValid: true,
      },
      arrivalDate: {
        value: "",
        isValid: true,
      },
      paymentStatus: {
        value: "no",
        isValid: true,
      },
      location: {
        value: "",
        isValid: true,
      }
      ,
    },
    false
  );

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+`/specialOrders/${specialOrderID}`,
          "GET",
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setIdentifiedSpecialOrder(responseData.specialOrder);
        setFormData(
          {
            style: {
              value: responseData.specialOrder.style.split('_')[0],
              isValid: true,
            },
            company: {
              value: responseData.specialOrder.company,
              isValid: true,
            },
            color: {
              value: responseData.specialOrder.color,
              isValid: true,
            },
            USSize: {
              value: responseData.specialOrder.USSize,
              isValid: true,
            },
            cost: {
              value: responseData.specialOrder.cost,
              isValid: true,
            },
            price: {
              value: responseData.specialOrder.price,
              isValid: true,
            },
            customer: {
              value: responseData.specialOrder.customer,
              isValid: true,
            },
            startDate: {
              value: responseData.specialOrder.startDate,
              isValid: true,
            },
            eventDate: {
              value: responseData.specialOrder.eventDate,
              isValid: true,
            },
            arrivalDate: {
              value: responseData.specialOrder.arrivalDate,
              isValid: true,
            },
            paymentStatus: {
              value: responseData.specialOrder.paymentStatus,
              isValid: true,
            },
            location: {
              value: responseData.specialOrder.location,
              isValid: true,
            },
          },
          true
        );
      } catch (err) {}
    };
    fetchOrder();
  }, [sendRequest, specialOrderID, setFormData, auth.token]);

  const placeUpdateSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL+`/specialOrders/${specialOrderID}/edit`,
        "PATCH",
        JSON.stringify({
          style: formState.inputs.style.value+
          "_" + Capitalize(formState.inputs.color.value) +
          "_" + Capitalize(formState.inputs.USSize.value),
          company: formState.inputs.company.value,
          color: formState.inputs.color.value,
          USSize: formState.inputs.USSize.value,
          cost: formState.inputs.cost.value,
          price: formState.inputs.price.value,
          customer: formState.inputs.customer.value,
          startDate: formState.inputs.startDate.value,
          eventDate: formState.inputs.eventDate.value + "T00:00:00.000Z",
          arrivalDate: formState.inputs.arrivalDate.value + "T00:00:00.000Z",
          paymentStatus: formState.inputs.paymentStatus.value,
          location: formState.inputs.location.value,
        }),
        {
          "Content-Type": "application/json",
          Authorization: 'Bearer '+ auth.token
        }
      );
      history.push(`/specialOrders/${specialOrderID}`);
    } catch (err) {}
  };
  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!identifiedSpecialOrder && !error) {
    return (
      <div className="center">
        <Card>
          <h2>Could not find the special order!</h2>
        </Card>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="center ">
        <LoadingSpinner />
      </div>
    );
  }
  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {!isLoading && identifiedSpecialOrder && (
        <li className="specialOrders-update-list" >
          <Card className="order-item__content">
            <h2 className="header-text">Edit Special Order</h2>
            <form className="place-form" onSubmit={placeUpdateSubmitHandler}>
            <div className="flex justify-center">
                <div className=" w-50  mr1">
                  <label>Order Number</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedSpecialOrder.orderNumber}
                  />
                </div>
                <div className=" w-50">
                  <label>Order Date</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedSpecialOrder.startDate.substring(0, 10)}
                  />
                </div>
              </div>
              <div className="flex justify-center" style={{textAlign:"Left"}}>
                <div className=" w-33  mr2">
                  <label>Name</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedSpecialOrder.customer.flat()[0] ? identifiedSpecialOrder.customer.flat()[0].name : " N/A" }
                  />
                </div>
                <div className=" w-33 mr2">
                  <label>Last Name</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedSpecialOrder.customer.flat()[0] ? identifiedSpecialOrder.customer.flat()[0].lastname : " N/A" }
                  />
                </div>
                <div className=" w-33">
                  <label>Phone</label>
                  <input
                    readOnly
                    type="text"
                    value={identifiedSpecialOrder.customer.flat()[0] ? formatPhoneNumber(identifiedSpecialOrder.customer.flat()[0].phone) : " N/A" }
                  />
                </div>
              </div>
                <div className="flex justify-center">
                  <div className=" w-33 mr2">
                  <label>
                    Style
                  </label>
                      <Input
                        id="style"
                        element="input"
                        type="text"
                        simple
                        validators={[
                          VALIDATOR_REQUIRE(),
                          VALIDATOR_MAXLENGTH(23),
                          VALIDATOR_SPECIAL_CHARACHTER()
                        ]}
                        errorText="Please enter a valid (Less than 23 characters) style."
                        onInput={inputHandler}
                        initialValue={formState.inputs.style.value}
                        initialValid={formState.inputs.style.isValid}
                      />
                  </div>
                  <div className=" w-33 mr2">
                  <label>
                    Company
                  </label>
                    <Input
                      id="company"
                      element="input"
                      simple
                      type="text"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(23),
                        VALIDATOR_SPECIAL_CHARACHTER()
                      ]}
                      errorText="Please enter a valid (Less than 23 characters) company."
                      onInput={inputHandler}
                      initialValue={formState.inputs.company.value}
                      initialValid={formState.inputs.company.isValid}
                    />
                  </div>
                  <div className=" w-33">
                  <label>
                    Color
                  </label>
                    <Input
                      id="color"
                      element="input"
                      simple
                      type="text"
                      validators={[
                        VALIDATOR_REQUIRE(),
                        VALIDATOR_MAXLENGTH(20),
                        VALIDATOR_SPECIAL_CHARACHTER()
                      ]}
                      errorText="Please enter less than 20 characters."
                      onInput={inputHandler}
                      initialValue={formState.inputs.color.value}
                      initialValid={formState.inputs.color.isValid}
                    />             
                  </div>                  
            </div>  
              <div className="flex justify-left">
                
                <div className="w-33 mr3">
                  <label>
                    Arrival Date
                  </label>
                      <Input
                      id="arrivalDate"
                      element="input"
                      type="date"
                      simple
                      customClass="w-100 date-custom-style"
                      validators={[VALIDATOR_REQUIRE()]}
                      errorText="Please enter a Date."
                      onInput={inputHandler}
                      initialValue={formState.inputs.arrivalDate.value.split('T')[0]}
                      initialValid={formState.inputs.arrivalDate.isValid}
                      />
                </div>
                <div className=" w-33 mr3">
                  <label>
                    Event Date
                  </label>
                  <Input
                    id="eventDate"
                    element="input"
                    simple
                    customClass="w-100 date-custom-style"
                    type="date"
                    validators={[VALIDATOR_REQUIRE()]}
                    errorText="Please enter a Date."
                    onInput={inputHandler}
                    initialValue={formState.inputs.eventDate.value.split('T')[0]}
                    initialValid={formState.inputs.eventDate.isValid}
                  />
                </div>
                <div className="w-33">
                  <label>
                    US Size
                  </label>
               <Input
                 id="USSize"
                 element="input"
                 simple
                 type="text"
                 validators={[
                  VALIDATOR_REQUIRE(),
                  VALIDATOR_MAXLENGTH(20),
                  VALIDATOR_SPECIAL_CHARACHTER()
                ]}
                 errorText="Please enter a valid US size."
                 onInput={inputHandler}
                 initialValue={formState.inputs.USSize.value}
                 initialValid={formState.inputs.USSize.isValid}
               />             
              </div>
              </div>              
              <div className="flex justify-center">
                  <div className=" w-33 mr2">
                  <label>Location</label>
                  <Input
                    id="location"
                    element="input"
                    simple
                    type="text"
                    validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(180),   VALIDATOR_SPECIAL_CHARACHTER()]}
                    errorText="Please enter a location."
                    onInput={inputHandler}
                    initialValue={formState.inputs.location.value}
                    initialValid={formState.inputs.location.isValid}
                  />
                </div>
                <div className=" w-33 mr2">
                  <label>Cost</label>
                  <Input
                    id="cost"
                    element="input"
                    simple
                    type="text"
                    validators={[VALIDATOR_REQUIRE(),VALIDATOR_NUMERIC(),  VALIDATOR_SPECIAL_CHARACHTER()]}
                    errorText="Please enter a cost."
                    onInput={inputHandler}
                    initialValue={formState.inputs.cost.value}
                    initialValid={formState.inputs.cost.isValid}
                  />
                </div>  <div className=" w-33 mr2">
                  <label>price</label>
                  <Input
                    id="price"
                    element="input"
                    simple
                    type="text"
                    validators={[VALIDATOR_REQUIRE(),VALIDATOR_NUMERIC(),  VALIDATOR_SPECIAL_CHARACHTER()]}
                    errorText="Please enter a price."
                    onInput={inputHandler}
                    initialValue={formState.inputs.price.value}
                    initialValid={formState.inputs.price.isValid}
                  />
                </div>
              </div>             
              <Button type="submit" disabled={!formState.isValid}>
                UPDATE ORDER
              </Button>
              <Button inverse to={`/specialOrders/${specialOrderID}`}>
                CANCEL
              </Button>
            </form>
          </Card>
        </li>
      )}
    </React.Fragment>
  );
};

export default UpdateSpecialOrder;
